module.exports = __webpack_public_path__ + "static/media/70.9020r.243b414a.pdf";